import { clientInvoicesQueryKey } from "utils/invoiceVerificationQueries";

export const modulePaymentsQueryKey = (moduleType, moduleId) => [
  "module-payments",
  moduleType,
  Number(moduleId),
];

export const moduleInvoiceQueryKey = (moduleType, moduleId) => [
  "module-invoice",
  moduleType,
  Number(moduleId),
];

/**
 * A module payment change is also an invoice change (its mirror row moves in the same request), so
 * every screen that shows either refreshes together: invoice totals, client badges, and the invoice
 * verification queue, which lists module payments too.
 */
export const invalidateModuleFinance = (queryClient, moduleType, moduleId, clientId) =>
  Promise.all(
    [
      modulePaymentsQueryKey(moduleType, moduleId),
      moduleInvoiceQueryKey(moduleType, moduleId),
      clientId != null ? clientInvoicesQueryKey(clientId) : null,
      ["invoice"],
      ["pending-module-payment-verifications"],
      ["client-summary"],
      ["invoiceSummary"],
      ["outstandingInvoices"],
      ["dashboardStats"],
      ["invoice-verification-pending"],
      ["invoice-verification-pending-count"],
    ]
      .filter(Boolean)
      .map((queryKey) => queryClient.invalidateQueries({ queryKey }))
  );
